"use strict";

import * as bindings from "./bindings";
export const init = function init() {
  bindings.bindActions();
};
$(document).ready(function () {
  var $sliderContainer = $(".index-hero__slider-container");
  if (!$sliderContainer.length) return;
  $sliderContainer.slick({
    infinite: true,
    speed: 500,
    arrows: false,
    fade: true,
    dots: true,
    lazyLoad: "ondemand",
    mobileFirst: true,
    cssEase: "linear",
    adaptiveHeight: true,
  });
  $(window).resize(function () {
    $sliderContainer[0].slick.refresh();
  });
});
